export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-500 to-yellow-600 rounded-2xl opacity-20 blur-xl"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/8d4d6b4326e38e3273a6f50769a3f382.jpg"
              alt="Feel Music Team"
              className="relative rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <div className="mb-6">
              <span className="text-amber-500 font-semibold text-sm uppercase tracking-wider">Quem Somos</span>
              <div className="w-20 h-1 bg-amber-500 mt-2"></div>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Mais de 20 Anos Criando Experiências Inesquecíveis
            </h2>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                Há mais de 20 anos, a <strong className="text-amber-500">Feel Music</strong> une a sensibilidade artística à segurança técnica. Nossa curadoria estuda o perfil do seu público para entregar não apenas músicos, mas uma experiência visual e sonora completa — do pianista solo à grande produção com Painéis de LED e Sonorização.
              </p>

              <p>
                É esse equilíbrio que faz marcas como <strong className="text-white">Itaú, Hospital Albert Einstein, Montblanc</strong> e <strong className="text-white">Rede Iguatemi</strong> confiarem em nós para seus eventos mais importantes.
              </p>

              <p>
                Combinamos curadoria artística refinada com estrutura técnica de ponta para criar atmosferas únicas que transformam eventos corporativos e sociais em experiências memoráveis.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">2.500+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Eventos</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">60+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Músicos</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-500 mb-2">20+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Anos</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
